import registerBinding from "common/bindings/registerBinding";

/**
 /**
 * A binding that works exactly like the built-in "value" binding for widgets.
 *
 * The binding will look for a "[fieldName]Change" event to update the binding.
 *
 * Usage: Current bindings exist in this file. In the future, they should be added in the appropriate widget file.
 *
 * For a widget to support the type binding, it would have to define a getter/setter method type().
 * It would also need to throw the event typeChange whenever the result of type() has changed
 * @param x
 * @returns {kendo.data.Binder} Returns the new binding.
 */

var FieldBinder = kendo.data.Binder.extend({

    //The field
    fieldName: "field",

    init: function() {
        kendo.data.Binder.fn.init.apply(this, arguments);
        this.change = $.proxy(this.change, this);
        this.element.bind(this.fieldName + "Change", this.change);
    },

    refresh: function() {
        var value = this.bindings[this.fieldName].get();
        this.element[this.fieldName](value);
    },

    change: function() {
        var value = this.element[this.fieldName]();
        this.bindings[this.fieldName].set(value);
    },

    destroy: function() {
        kendo.data.Binder.fn.destroy.apply(this, arguments);
        this.element.unbind(this.fieldName + "Change", this.change);
    }
});



//All current field bindings.
kendo.data.binders.widget.allColumns = FieldBinder.extend({
    fieldName: "allColumns"
});
kendo.data.binders.widget.allowEdit = FieldBinder.extend({
    fieldName: "allowEdit"
});
kendo.data.binders.widget.back = FieldBinder.extend({
    fieldName: "back"
});
kendo.data.binders.widget.breadcrumbsDS = FieldBinder.extend({
    fieldName: "breadcrumbsDS"
});
kendo.data.binders.widget.busy = FieldBinder.extend({
    fieldName: "busy"
});
kendo.data.binders.widget.buttons = FieldBinder.extend({
    fieldName: "buttons"
});
kendo.data.binders.widget.categoryId = FieldBinder.extend({
    fieldName: "categoryId"
});
kendo.data.binders.widget.categoryName = FieldBinder.extend({
    fieldName: "categoryName"
});
kendo.data.binders.widget.claimDS = FieldBinder.extend({
    fieldName: "claimDS"
});
kendo.data.binders.widget.columnVariables = FieldBinder.extend({
    fieldName: "columnVariables"
});
kendo.data.binders.widget.confirm = FieldBinder.extend({
    fieldName: "confirm"
});
kendo.data.binders.widget.confirming = FieldBinder.extend({
    fieldName: "confirming"
});
kendo.data.binders.widget.controlsDS = FieldBinder.extend({
    fieldName: "controlsDS"
});
kendo.data.binders.widget.dashboard = FieldBinder.extend({
    fieldName: "dashboard"
});
kendo.data.binders.widget.dataType = FieldBinder.extend({
    fieldName: "dataType"
});
kendo.data.binders.widget.dirty = FieldBinder.extend({
    fieldName: "dirty"
});
kendo.data.binders.widget.disableRowsReorderable = FieldBinder.extend({
    fieldName: "disableRowsReorderable"
});
kendo.data.binders.widget.displayField = FieldBinder.extend({
    fieldName: "displayField"
});
kendo.data.binders.widget.displayText = FieldBinder.extend({
    fieldName: "displayText"
});
kendo.data.binders.widget.enableSelection = FieldBinder.extend({
    fieldName: "enableSelection"
});
kendo.data.binders.widget.externalEdit = FieldBinder.extend({
    fieldName: "externalEdit"
});
kendo.data.binders.widget.fore = FieldBinder.extend({
    fieldName: "fore"
});
kendo.data.binders.widget.formName = FieldBinder.extend({
    fieldName: "formName"
});
kendo.data.binders.widget.guidelines = FieldBinder.extend({
    fieldName: "guidelines"
});
kendo.data.binders.widget.height = FieldBinder.extend({
    fieldName: "height"
});
kendo.data.binders.widget.input = FieldBinder.extend({
    fieldName: "input"
});
kendo.data.binders.widget.inputs = FieldBinder.extend({
    fieldName: "inputs"
});
kendo.data.binders.widget.inputsDS = FieldBinder.extend({
    fieldName: "inputsDS"
});
kendo.data.binders.widget.inUse = FieldBinder.extend({
    fieldName: "inUse"
});
kendo.data.binders.widget.listItems = FieldBinder.extend({
    fieldName: "listItems"
});
kendo.data.binders.widget.loading = FieldBinder.extend({
    fieldName: "loading"
});
kendo.data.binders.widget.mask = FieldBinder.extend({
    fieldName: "mask"
});
kendo.data.binders.widget.maxValue = FieldBinder.extend({
    fieldName: "maxValue"
});
kendo.data.binders.widget.minValue = FieldBinder.extend({
    fieldName: "minValue"
});
kendo.data.binders.widget.packageDS = FieldBinder.extend({
    fieldName: "packageDS"
});
kendo.data.binders.widget.packageItemsDS = FieldBinder.extend({
    fieldName: "packageItemsDS"
});
kendo.data.binders.widget.processVarsDS = FieldBinder.extend({
    fieldName: "processVarsDS"
});
kendo.data.binders.widget.progress = FieldBinder.extend({
    fieldName: "progress"
});
kendo.data.binders.widget.prompts = FieldBinder.extend({
    fieldName: "prompts"
});
kendo.data.binders.widget.prompts = FieldBinder.extend({
    fieldName: "prompts"
});
kendo.data.binders.widget.rangeValue = FieldBinder.extend({
    fieldName: "rangeValue"
});
kendo.data.binders.widget.readOnly = FieldBinder.extend({
    fieldName: "readOnly"
});
kendo.data.binders.widget.scopes = FieldBinder.extend({
    fieldName: "scopes"
});
kendo.data.binders.widget.searchType = FieldBinder.extend({
    fieldName: "searchType"
});
kendo.data.binders.widget.showGrid = FieldBinder.extend({
    fieldName: "showGrid"
});
kendo.data.binders.widget.skipRequired = FieldBinder.extend({
    fieldName: "skipRequired"
});
kendo.data.binders.widget.softInUse = FieldBinder.extend({
    fieldName: "softInUse"
});
kendo.data.binders.widget.subSearches = FieldBinder.extend({
    fieldName: "subSearches"
});
kendo.data.binders.widget.suggestForMobile = FieldBinder.extend({
    fieldName: "suggestForMobile"
});
kendo.data.binders.widget.type = FieldBinder.extend({
    fieldName: "type"
});
kendo.data.binders.widget.useSnap = FieldBinder.extend({
    fieldName: "useSnap"
});
kendo.data.binders.widget.variables = FieldBinder.extend({
    fieldName: "variables"
});
kendo.data.binders.widget.varsDS = FieldBinder.extend({
    fieldName: "varsDS"
});
kendo.data.binders.widget.x = FieldBinder.extend({
    fieldName: "x"
});
kendo.data.binders.widget.y = FieldBinder.extend({
    fieldName: "y"
});

export default FieldBinder;
export function register(Widget, fieldName) {
    const binder = FieldBinder.extend({fieldName: fieldName});
    registerBinding.widget(Widget.prototype.options.name.toLowerCase(), fieldName, binder)
}
